import { AbstractSearchDataMessage } from "./abstractSearchDataMessage"

export class SaveSearchMessage extends AbstractSearchDataMessage {
}
